import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import { createTrialSubMenu } from "src/routing/navigation";

/**
 * Registers the trial submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const TrialSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);

    const subMenu = useMemo(
        () => {
            if (!trialIdentity) {
                return null;
            }

            return createTrialSubMenu(trialIdentity);
        },
        [trialIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default TrialSubMenu;
